import {ComponentSelectors, ComponentElements, UIComponent, ComponentInjector, ComponentObject, ComponentService} from '@atypon/ui-utils'
import { VPortListener } from "ui-core/plugins/enquireJs/js/helper"

class Texts extends ComponentObject{} 

class ClassList extends ComponentObject{}

class Selectors extends ComponentSelectors{
    collapsibleMenu = '.collapsible-menu'; 
    collapsibleMenuHeader = '.collapsible-menu-header';
    collapsibleMenuBody = '.collapsible-menu-body'; 
    collapsibleMenuButton= '.collapsible-menu-header button';
    arrowIcon= '.collapsible-menu-header .icon';
}

class Elements extends ComponentElements<Selectors>{
    collapsibleMenus: Array<HTMLElement>= []; 
    collapsibleMenuHeaders: Array<HTMLElement>= []; 
}

interface CollapsibleList extends ComponentService<Selectors, Elements, ClassList, Texts> {}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class CollapsibleList implements UIComponent{

    @VPortListener('md')
    isTablet= false;

    initialize(): void {
        this.setElements();
        this.addEventListeners();
    }

    private setElements(): void {
        this.elements.collapsibleMenus = this.domUtils.getElements(this.selectors.collapsibleMenu); 
        this.elements.collapsibleMenuHeaders = this.domUtils.getElements(this.selectors.collapsibleMenuHeader);
    }

    isTabletOn() {
        this.isTablet = true;
    }

    isTabletOff() {
        this.isTablet = false;
    } 
    
    addEventListeners(): void {
        document.addEventListener('DOMContentLoaded', ()=>this.checkIsTablet());
    }

    private checkIsTablet() {
        window.innerWidth < 992 && (this.elements.collapsibleMenus?.forEach((header) => {
            header.addEventListener('click', (event) => { this.handleCollapsibleList(event) });
        }))
    }

    private handleCollapsibleList(event):void {
        event.stopPropagation();
        const wrapper = event.target.closest(this.selectors.collapsibleMenu);
        const collapsibleMenuBody= this.domUtils.getElement(this.selectors.collapsibleMenuBody, wrapper);
        const collapsibleMenuButton= this.domUtils.getElement(this.selectors.collapsibleMenuButton, wrapper);
        const arrowIcon= this.domUtils.getElement(this.selectors.arrowIcon, wrapper);

        wrapper?.classList.toggle('js--open');
        const isOpen = wrapper?.classList.contains('js--open');

        if(isOpen){
            collapsibleMenuBody.style.display =  'block' ;
            collapsibleMenuBody.style.marginBottom =  '10px' ;
            collapsibleMenuBody.style.maxHeight= `${collapsibleMenuBody.scrollHeight}px`;
        }
        else {
            collapsibleMenuBody.style.maxHeight= '0px';
            collapsibleMenuBody.style.marginBottom =  '0';
        }

        arrowIcon?.classList.toggle('icon-chevron-down');
        arrowIcon?.classList.toggle('icon-chevron-up');

        collapsibleMenuButton?.setAttribute('aria-expanded', `${isOpen}`);
    }
}

export default CollapsibleList;

export{
    Texts as CollapsibleListTexts,
    ClassList as CollapsibleListClassList,
    Selectors as CollapsibleListSelectors,
    Elements as CollapsibleListElements,
};